export const audits = {
  title: 'Audit logs',
  titles: {
    list: 'Audit logs',
  },
  fields: {
    createdAt: 'Time',
    timeAndUser: 'Time / User',
    entityType: 'Entity type',
    entityTypeShort: 'Entity',
    entityMeta: 'Entity / Act / ID',
    action: 'Action',
    actionShort: 'Act.',
    entityId: 'Entity ID',
    userName: 'Actor',
    ipAddress: 'IP',
    description: 'Description',
    changeDetail: 'Summary / context',
    changeContent: 'Change content',
    relatedCodes: 'Related codes',
    contextLabels: {
      donHang: 'SO',
      hoaDon: 'INV',
      traHang: 'RT',
      khachHang: 'Cust',
      hang: 'Goods',
      sp: 'SKU',
      nhom: 'Grp',
      ncc: 'Sup',
      bangGia: 'PL',
      pk: 'STK',
      pn: 'GR',
      ycx: 'IR',
      sc: 'RP',
      pt: 'RC',
      pc: 'PY',
      tkq: 'CA',
    },
    beforeChange: 'Before',
    afterChange: 'After',
    requestInfo: 'Source',
    duAn: 'Project',
    chiNhanh: 'Branch',
    nguon: 'Source',
    maThietBi: 'Device ID',
    ungDung: 'App',
    manHinh: 'Screen',
    tenApi: 'Operation',
    hamXuLy: 'Handler',
    device: 'Device',
    api: 'API',
  },
  nguon: {
    WEB: 'WEB',
    MOBILE: 'Mobile app',
    API: 'Direct API',
  },
  filter: {
    placeholder: 'Search description, codes, IDs…',
    advancedFilter: 'Advanced filters',
    search: 'Search',
    ma: 'Code (order / invoice / SKU)',
    maPlaceholder: 'Order, invoice, product code…',
    entityType: 'Entity type',
    entityId: 'Entity ID',
    userId: 'User ID',
    user: 'User',
    action: 'Action',
    chiNhanh: 'Branch',
    phamVi: 'Scope',
    phamViHienTai: 'Current project',
    phamViTatCa: 'All projects',
    duAn: 'Project',
    nhomHanhDong: 'Action group',
    nhomHanhDongOptions: {
      taiKhoan: 'Account (login, password…)',
      nghiepVu: 'Business (data changes)',
    },
    ipAddress: 'IP address',
    ipAddressPlaceholder: 'e.g. 113.161',
    thietBi: 'Device / browser',
    thietBiPlaceholder: 'e.g. iPhone, Samsung, Chrome, device ID',
    duongDan: 'API (path / name)',
    duongDanPlaceholder: 'e.g. /dat-hang, Create invoice',
    phuongThuc: 'Method',
    nguonThaoTac: 'Request source',
    nguon: 'Source',
    manHinh: 'Screen / page',
    manHinhPlaceholder: 'e.g. /admin/hoa-don, DonHangChiTiet',
    sortFields: {
      ngayTao: 'Time',
      entityType: 'Entity type',
      entityId: 'Entity ID',
      userId: 'Actor',
      action: 'Action',
      id: 'Log ID',
    },
    fromDate: 'From date',
    toDate: 'To date',
    all: 'All',
    clearFilter: 'Clear filters',
    apply: 'Apply',
    clear: 'Clear',
  },
  messages: {
    noData: 'No audit logs',
    totalLogs: 'Total: {total} logs',
    emptyValue: 'Empty',
    noChangeDetail: 'No field-level changes recorded',
    moreChanges: 'and {count} more changes',
    fieldChangeCount: '{count} field(s) changed',
  },
  export: {
    button: 'Export',
    fileName: 'audit_logs_{date}.xlsx',
    sheetName: 'Audit logs',
    success: 'Exported Excel successfully',
    failed: 'Export failed',
    loading: 'Exporting...',
  },
  entityTypes: {
    DMHangHoaChiNhanh: 'Branch product',
    DMHangHoa: 'Product',
    DMSanPham: 'SKU',
    DMNhomSanPham: 'Product category',
    DMNhomHang: 'Item group',
    DMDonViTinh: 'Unit',
    DMNhaCungCap: 'Supplier',
    DMKhachHang: 'Customer',
    DMNhomKhachHang: 'Customer group',
    DMDiaChiNhanHang: 'Delivery address',
    DMThongTinXuatHoaDon: 'Invoice profile',
    DMDoiTacGiaoHang: 'Delivery partner',
    DMNhomDoiTacGiaoHang: 'Delivery partner group',
    DMDichVuGiaoHang: 'Delivery service',
    HTTichHopNhaVanChuyen: 'Carrier integration',
    DMBangGia: 'Price list',
    HTCaiDatBanHang: 'Sales settings',
    PKCH: 'Branch stock voucher',
    PKCT: 'Stock voucher line',
    PNhanHPhieuNhanHang: 'Goods receipt',
    DHHoaDon: 'Invoice',
    DHDonHang: 'Order',
    DHPhieuTraHang: 'Return voucher',
    SCYeuCauSuaChua: 'Repair request',
    HTNguoiDung: 'User',
    SQuyPhieuThu: 'Receipt voucher',
    SQuyPhieuChi: 'Payment voucher',
    SQuyTaiKhoanQuy: 'Cash account',
    DHYeuCauXuatHoaDon: 'Invoice request',
    HTMauIn: 'Print template',
    CNGiaoDich: 'Receivable transaction',
    CNChotCongNo: 'Receivable closing',
  },
  actions: {
    CREATE: 'Create',
    UPDATE: 'Update',
    DELETE: 'Delete',
    STATUS_CHANGE: 'Status change',
    CREATE_PHIEU_THU: 'Create receipt',
    UPDATE_PHIEU_THU: 'Update receipt',
    SUBMIT_FOR_APPROVAL: 'Submit for approval',
    APPROVE_PHIEU_THU: 'Approve receipt',
    REJECT_PHIEU_THU: 'Reject receipt',
    CANCEL_PHIEU_THU: 'Cancel receipt',
    DELETE_PHIEU_THU: 'Delete draft receipt',
    CREATE_PHIEU_CHI: 'Create payment',
    UPDATE_PHIEU_CHI: 'Update payment',
    APPROVE_PHIEU_CHI: 'Approve payment',
    REJECT_PHIEU_CHI: 'Reject payment',
    CANCEL_PHIEU_CHI: 'Cancel payment',
    DELETE_PHIEU_CHI: 'Delete draft payment',
    CREATE_TAI_KHOAN_QUY: 'Create cash account',
    UPDATE_TAI_KHOAN_QUY: 'Update cash account',
    ACTIVATE_TAI_KHOAN_QUY: 'Activate cash account',
    DEACTIVATE_TAI_KHOAN_QUY: 'Deactivate cash account',
    DELETE_TAI_KHOAN_QUY: 'Delete cash account',
    CREATE_YCX: 'Create invoice request',
    GUI_KT: 'Send to accounting',
    GUI_KHACH: 'Send to customer',
    KHACH_DONG_Y: 'Customer approved',
    KHACH_KHONG_DONG_Y: 'Customer rejected',
    HOAN_THANH: 'Completed',
    HUY: 'Cancelled',
    DANG_NHAP: 'Login',
    DANG_NHAP_THAT_BAI: 'Login failed',
    DANG_XUAT: 'Logout',
    DOI_CHI_NHANH: 'Switch branch',
    DOI_MAT_KHAU: 'Change password',
    CAP_NHAT_HO_SO: 'Update profile',
  },
}
